document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('#product-detail-slider')) {

    var mainSlider = new Splide('#product-detail-slider', {
      type: 'fade',
      rewind: true,
      pagination: false,
      arrows: false,
      breakpoints: {
        750: {
          arrows: true,
        }
      }
    });

    // メインスライダーのみマウント
    mainSlider.mount();

    var thumbnails = document.querySelectorAll('.product-detail__thumbnail');

    function updateActive(index) {
      thumbnails.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === index);
      });
    }

    // ✅ SET INITIAL ACTIVE STATE (FIX)
    updateActive(mainSlider.index || 0);

    // When main slider moves
    mainSlider.on('moved', function (newIndex) {
      if (window.innerWidth > 750) {
        updateActive(newIndex);
      }
    });

    // Desktop click
    thumbnails.forEach((thumb, index) => {
      thumb.addEventListener('click', function () {
        if (window.innerWidth > 750) {
          mainSlider.go(index);
          updateActive(index);
        }
      });
    });

  }
});

//stepper
let count = 0;
function updateDisplay() {
  const countEl = document.getElementById('count');
  if (!countEl) return;
  countEl.textContent = String(count).padStart(2, '0');
}

function increase() {
  count++;
  updateDisplay();
}

function decrease() {
  if (count > 0) count--;
  updateDisplay();
}

updateDisplay();

jQuery(function ($) {
  tabParent = $('.p-details_otherInfo__title'),
    tabChild = $('.p-details_otherInfo__content')

  $(tabParent).on("click", function () {
    $(this).next(tabChild).slideToggle(500);
    $(this).toggleClass('is-tap');
    if (!($(this).hasClass('is-tap'))) {
      $(this).removeClass('is-tap');
    }
  });
});

//size active 
$('.p__size').on('click', '.p__size__item', function () {
  $('.p__size__item').removeClass('-active');
  $(this).addClass('-active');
});

//color active
$('.p__colors').on('click', '.p__colors__item', function () {
  $('.p__colors__item').removeClass('-active');
  $(this).addClass('-active');
});

document.addEventListener('DOMContentLoaded', function () {
  if ($('#js-recommend_detail').length) {
    var splide = new Splide('#js-recommend_detail', {
      type: 'loop',
      focus: 'center',
      autoWidth: false,
      gap: '25px',
      arrows: false,
      pagination: true,
      padding: '15%',
      breakpoints: {
        750: {
          destroy: true,
        },
      }
    });
    splide.mount();
  }
});

// ==========================================
// Sticky Cart の表示・非表示コントロール（画面中央で発火）
// ==========================================
document.addEventListener('DOMContentLoaded', function () {
  const stickyCart = document.querySelector('.sticky-cart');
  const targetElement = document.querySelector('.product-detail__btns');

  if (stickyCart && targetElement) {
    window.addEventListener('scroll', function () {
      const rect = targetElement.getBoundingClientRect();
      const windowCenter = window.innerHeight / 2;

      if (rect.bottom < windowCenter) {
        stickyCart.classList.add('is-visible');
      } else {
        stickyCart.classList.remove('is-visible');
      }
    });
  }
});

// ==========================================
// SP 商品画像 全画面表示
// ==========================================
document.addEventListener('DOMContentLoaded', function () {
  const mqSp = window.matchMedia('(max-width: 749px)');

  const modal = document.querySelector('#product-fullscreen');
  const sliderEl = document.querySelector('#product-fullscreen-slider');
  const openBtns = document.querySelectorAll('.js-product-fullscreen-open');
  const closeBtn = document.querySelector('.product-fullscreen__close');
  const current = document.querySelector('.js-fullscreen-current');
  const total = document.querySelector('.js-fullscreen-total');

  const fullscreenWishlistBtn = document.querySelector('.js-fullscreen-wishlist');
  const fullscreenCartBtn = document.querySelector('.js-fullscreen-cart');

  if (!modal || !sliderEl || !openBtns.length) return;

  let scrollPosition = 0;
  let isModalOpen = false;

  const fullscreenSlider = new Splide('#product-fullscreen-slider', {
    type: 'loop',
    perPage: 1,
    perMove: 1,
    pagination: false,
    arrows: true,
  });

  fullscreenSlider.mount();

  document.querySelectorAll('#product-fullscreen-slider .splide__arrow svg').forEach((svg) => {
    svg.setAttribute('viewBox', '0 0 10 6');
    svg.removeAttribute('width');
    svg.removeAttribute('height');

    svg.innerHTML = `
      <path
        fill="currentColor"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708"
      />
    `;
  });

  if (total) total.textContent = fullscreenSlider.length;

  function updateCount() {
    if (current) current.textContent = fullscreenSlider.index + 1;
  }

  function syncMainGallery(index = fullscreenSlider.index) {
    const opener = document.querySelector(
      `.js-product-fullscreen-open[data-fullscreen-index="${index}"]`
    );

    if (!opener) return;

    const slide = opener.closest('.product__media-item');
    if (!slide) return;

    const mediaId = slide.dataset.mediaId;
    if (!mediaId) return;

    const mediaGallery = document.querySelector('media-gallery');

    if (mediaGallery && typeof mediaGallery.setActiveMedia === 'function') {
      mediaGallery.setActiveMedia(mediaId, false);
      return;
    }

    const thumbnail = document.querySelector(`[data-target="${mediaId}"] button`);
    if (thumbnail) thumbnail.click();
  }

  function openModal(index) {
    if (!mqSp.matches) return;

    scrollPosition = window.pageYOffset;
    isModalOpen = true;

    syncMainGallery(index);

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');

    document.body.classList.add('is-product-fullscreen-open');
    document.body.style.top = `-${scrollPosition}px`;

    fullscreenSlider.go(index);
    updateCount();
  }

  function closeModal() {
    if (!isModalOpen) return;

    syncMainGallery();

    requestAnimationFrame(function () {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');

      document.body.classList.remove('is-product-fullscreen-open');
      document.body.style.top = '';

      window.scrollTo(0, scrollPosition);
      isModalOpen = false;
    });
  }

  function clickRealWishlistButton() {
    const realFavoriteBtn =
      document.querySelector('.product-favorite-button') ||
      document.querySelector('[id^="favorite-button-"]');

    if (!realFavoriteBtn) {
      console.warn('お気に入りボタンが見つかりません');
      return;
    }

    realFavoriteBtn.click();
  }

  function clickRealCartButton() {
    const realCartBtn =
      document.querySelector('.product-form__submit') ||
      document.querySelector('button[name="add"]') ||
      document.querySelector('[type="submit"][name="add"]');

    if (realCartBtn) realCartBtn.click();
  }

  fullscreenSlider.on('mounted moved', function () {
    updateCount();

    if (isModalOpen) {
      syncMainGallery();
    }
  });

  updateCount();

  openBtns.forEach((btn) => {
    btn.addEventListener('click', function (e) {
      if (!mqSp.matches) return;

      e.preventDefault();
      e.stopPropagation();

      const index = Number(btn.dataset.fullscreenIndex || 0);
      openModal(index);
    });
  });

  fullscreenWishlistBtn?.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    clickRealWishlistButton();
  });

  fullscreenCartBtn?.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    clickRealCartButton();
  });

  closeBtn?.addEventListener('click', closeModal);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });

  mqSp.addEventListener('change', function () {
    closeModal();
  });
});

// ==========================================
// PC 商品画像 虫眼鏡ズーム
// ==========================================
document.addEventListener('DOMContentLoaded', function () {
  const mqPc = window.matchMedia('(min-width: 750px)');

  const zoomTargets = document.querySelectorAll('.product__media img');
  if (!zoomTargets.length) return;

  const preview = document.createElement('div');
  preview.className = 'product-zoom-preview';
  document.body.appendChild(preview);

  const lens = document.createElement('div');
  lens.className = 'product-zoom-lens';

  const cursorIcon = document.createElement('div');
  cursorIcon.className = 'product-zoom-cursor';
  document.body.appendChild(cursorIcon);

  const zoom = 2.2;
  const gap = 40;

  let activeImg = null;
  let isOpen = false;

  function closeZoom() {
    preview.classList.remove('is-active');
    preview.removeAttribute('style');

    lens.classList.remove('is-active');
    lens.removeAttribute('style');

    cursorIcon.classList.remove('is-active');
    cursorIcon.removeAttribute('style');

    if (lens.parentNode) {
      lens.parentNode.removeChild(lens);
    }

    activeImg = null;
    isOpen = false;
  }

  function moveCursorIcon(e) {
    cursorIcon.style.left = `${e.pageX + 16}px`;
    cursorIcon.style.top = `${e.pageY + 16}px`;
  }

  function updateZoomPosition(e) {
    if (!mqPc.matches) {
      closeZoom();
      return;
    }

    const targetImg = e.target.closest('.product__media img');

    if (targetImg && !isOpen) {
      cursorIcon.classList.add('is-active');
      moveCursorIcon(e);
    }

    if (!activeImg || !isOpen) return;

    const rect = activeImg.getBoundingClientRect();

    const isOutside =
      e.clientX < rect.left ||
      e.clientX > rect.right ||
      e.clientY < rect.top ||
      e.clientY > rect.bottom;

    if (isOutside) {
      closeZoom();
      return;
    }

    moveCursorIcon(e);

    const previewWidth = preview.offsetWidth;
    const previewHeight = preview.offsetHeight;

    const lensWidth = previewWidth / zoom;
    const lensHeight = previewHeight / zoom;

    const lensX = Math.max(
      0,
      Math.min(e.clientX - rect.left - lensWidth / 2, rect.width - lensWidth)
    );

    const lensY = Math.max(
      0,
      Math.min(e.clientY - rect.top - lensHeight / 2, rect.height - lensHeight)
    );

    lens.style.width = `${lensWidth}px`;
    lens.style.height = `${lensHeight}px`;
    lens.style.left = `${lensX}px`;
    lens.style.top = `${lensY}px`;

    preview.style.backgroundPosition = `-${lensX * zoom}px -${lensY * zoom}px`;
  }

  function openZoom(img, e) {
    if (!mqPc.matches) return;

    const rect = img.getBoundingClientRect();
    const media = img.closest('.product__media');

    if (media && !media.contains(lens)) {
      media.appendChild(lens);
    }

    preview.style.width = `${rect.width}px`;
    preview.style.height = `${rect.height}px`;
    preview.style.left = `${window.scrollX + rect.right + gap}px`;
    preview.style.top = `${window.scrollY + rect.top}px`;
    preview.style.backgroundImage = `url(${img.currentSrc || img.src})`;
    preview.style.backgroundSize = `${rect.width * zoom}px ${rect.height * zoom}px`;

    preview.classList.add('is-active');
    lens.classList.add('is-active');
    cursorIcon.classList.add('is-active');

    activeImg = img;
    isOpen = true;

    updateZoomPosition(e);
  }

  zoomTargets.forEach((img) => {
    img.addEventListener('mouseenter', function (e) {
      if (!mqPc.matches || isOpen) return;

      cursorIcon.classList.add('is-active');
      moveCursorIcon(e);
    });

    img.addEventListener('mousemove', function (e) {
      if (!mqPc.matches) return;

      moveCursorIcon(e);
    });

    img.addEventListener('mouseleave', function () {
      if (!mqPc.matches || isOpen) return;

      cursorIcon.classList.remove('is-active');
    });

    img.addEventListener('click', function (e) {
      if (!mqPc.matches) return;

      e.preventDefault();
      e.stopPropagation();

      if (isOpen && activeImg === img) {
        closeZoom();
        return;
      }

      openZoom(img, e);
    });
  });

  document.addEventListener('mousemove', updateZoomPosition);

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.product__media')) {
      closeZoom();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeZoom();
  });

  mqPc.addEventListener('change', function () {
    closeZoom();
  });
});